import {
  ActivatedRouteSnapshot,
  Resolve,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { ApiHelper } from './apiHelper';
import { environment } from '../../environments/environment';
import { PostsDAO } from './dao/postsDAO';
import { map, take } from 'rxjs/operators';

@Injectable()
export class SeoLocationPageResolve implements Resolve<any> {
  constructor(
    private apiHelper: ApiHelper,
    private readonly router: Router,
    private readonly postsDAO: PostsDAO,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let postsResolve = this.postsDAO.getPost(state.url.split('?')[0]);

    return postsResolve.pipe(
      take(1),
      map((data) => data),
    );
  }
}
